/* eslint-disable no-underscore-dangle */
import { WebRequest } from '@cgn/framework-ui-components/v1';

/**
 * Restituisce, ordinati per score, una lista di contenuti simili in base ad alcune caratteristiche del quesito.
 * @param {string} baseUrl url base
 * @param {string} titolo titolo quesito
 * @param {string} messaggio messaggio quesito
 * @param {string} codiceArea codice area questito
 * @param {number} numeroRisultati numero risultati richiesti
 */
// eslint-disable-next-line import/prefer-default-export
export function loadContenutiSimiliAQuesito(
  codiceUfficio,
  titolo,
  messaggio,
  codiceArea,
  numeroRisultati,
) {
  return WebRequest.post('/Ricerca/ContenutiSimiliAQuesito', {
    CodiceUfficio: codiceUfficio,
    Titolo: titolo,
    Messaggio: messaggio,
    CodiceArea: codiceArea,
    NumeroRisultati: numeroRisultati,
  }).then((res) => {
    let resObj = res;
    if (typeof resObj === 'string') {
      resObj = (res && JSON.parse(res)) || { hits: { hits: [] } };
    }
    return resObj.hits.hits.map((item) => ({
      IdContenuto: item._id,
      IdArea: item._source.IdArea,
      Titolo: item._source.Titolo,
      Score: item.Score,
      DossierContenuto: item._source.DossierContenuto,
    }));
  });
}
